import BrandLogo from '../../../../common/BrandLogo';
import { getWhatsAppUrl, WHATSAPP_PHONE, DISPLAY_PHONE } from '../../../../config/contact';

'use client'

export default function Footer() {
  return (
    <footer className="bg-text-800 pt-12 pb-8">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 pb-8">
          {/* Logo and Tagline */}
          <div className="col-span-1 flex flex-col items-center md:items-start">
          <BrandLogo href={null} />
            <p className="mt-4 text-background-300 text-sm max-w-xs text-center md:text-left">
              Digital menu solutions that help restaurants go paperless and provide a better dining experience.
            </p>
          </div>
          
          {/* Quick Links */}
          <div className="col-span-1 flex flex-col items-center md:items-start">
            <h3 className="text-white font-medium mb-4">Links</h3>
            <div className="flex space-x-4 mb-4">
              <a href="/privacy" className="text-background-400 hover:text-accent-300 transition">Privacy</a>
              <span className="text-text-600">·</span>
              <a href="/terms" className="text-background-400 hover:text-accent-300 transition">Terms</a>
              <span className="text-text-600">·</span>
              <a href="/refund-policy" className="text-background-400 hover:text-accent-300 transition">Refund Policy</a>
            </div>
            <div className="flex flex-col items-center md:items-start space-y-2">
              <a href="/#pricing" className="text-background-400 hover:text-accent-300 transition">Pricing</a>
              <a href="/#how-it-works" className="text-background-400 hover:text-accent-300 transition">How it Works</a>
              <a href="/#faq" className="text-background-400 hover:text-accent-300 transition">FAQ</a>
            </div>
          </div>
          
          {/* Contact Information */}
          <div className="col-span-1 flex flex-col items-center md:items-start">
            <h3 className="text-white font-medium mb-4">Contact Us</h3>
            <div className="flex flex-col space-y-3 items-center md:items-start">
              <a href="mailto:hello@scanmaadi.in" className="text-background-400 hover:text-accent-300 transition flex items-center">
                <span className="mr-2">📧</span> hello@scanmaadi.in
              </a>
              <a href={`tel:+${WHATSAPP_PHONE}`} className="text-background-400 hover:text-accent-300 transition flex items-center">
                <span className="mr-2">📞</span> {DISPLAY_PHONE}
              </a>
              <div className="flex items-center mt-2">
                <a 
                  href={getWhatsAppUrl()}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="bg-accent-500 hover:bg-accent-600 text-white px-4 py-2 rounded-lg text-sm flex items-center transition"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" className="w-4 h-4 mr-2" viewBox="0 0 24 24">
                    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                  </svg>
                  WhatsApp Us
                </a>
              </div>
            </div>
          </div>
        </div>
        
        {/* Divider */}
        <div className="border-t border-text-700 pt-8 mt-4">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <div className="text-background-500 text-sm text-center md:text-left">
              <p>© 2025 ScanMaadi. All rights reserved.</p>
            </div>
            <div className="text-background-500 text-sm mt-4 md:mt-0 text-center md:text-right">
              <p className="flex items-center justify-center md:justify-end">
                Built in India 
                <span className="mx-1">🇮🇳</span> 
                for India's food heroes
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}